import Vue from 'vue'
import Router from 'vue-router'
import HashtagSuggestions from '../ritetag/HashtagSuggestions'
import HashtagReports from '../ritetag/HashtagReports'
import HashtagSets from '../ritetag/HashtagSets'
import BannedInstagram from '../ritetag/BannedInstagram'
import HashtagComparison from '../ritetag/HashtagComparison'
import Login from '../ritetag/Login'
import InstaGeneratorTeaser from '../ritetag/InstaGeneratorTeaser'
import InstagramReportDashboard from '../ritetag/InstagramReports'
import InstagramReport from '../ritetag/reports/Instagram'
import Composer from '../ritetag/helpers/Composer'

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/hashtag-suggestions',
            component: HashtagSuggestions,
            meta: {
                title: 'Hashtag Suggestions for Text and Images'
            }
        },
        {
            path: '/hashtag-reports',
            component: HashtagReports,
            meta: {
                title: 'Twitter Hashtag Reports'
            }
        },
        {
            path: '/instagram-coach-reports',
            component: InstagramReportDashboard,
            meta: {
                title: 'Instagram Account Coach'
            }
        },
        {
            path: '/instagram-coach-reports/:uuid([0-9a-f]+-[0-9a-f]+-[0-9a-f]+-[0-9a-f]+-[0-9a-f]+)',
            component: InstagramReport,
            meta: {
                title: 'Instagram Account Coach Report'
            }
        },
        {
            path: '/tagsets',
            component: HashtagSets,
            meta: {
                title: 'Hashtag Sets'
            }
        },
        {
            path: '/instagram-banned-hashtags-tool',
            component: BannedInstagram,
            meta: {
                title: 'Remove Banned Instagram Hashtags'
            }
        },
        {
            path: '/instagram-hashtag-generator',
            component: InstaGeneratorTeaser,
            meta: {
                title: 'Instagram Hashtag Generator Mobile App'
            }
        },
        {
            path: '/hashtag-comparison',
            component: HashtagComparison,
            meta: {
                title: 'Hashtag Comparison'
            }
        },
        {
            path: '/composer',
            component: Composer
        },
        {
            path: '*',
            redirect: '/hashtag-suggestions'
        }
    ]
})

const checkPath = (path, publicPages) => {
    for(let c of publicPages) {
        if (typeof c === 'string') {
            if (c === path) {
                return true
            }
        } else {
            if (c.test(path)) {
                return true
            }
        }
    }
    return false
}

router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if(!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
    // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

router.beforeEach((to, from, next) => {

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login', '/register', '/instagram-banned-hashtags-tool', '/instagram-hashtag-generator', /^\/instagram-coach-reports\/[a-f0-9-]+$/i];
    const onlyLoggedOut = ['/login', '/register']
    const authRequired = !checkPath(to.path, publicPages)

    if (to.query.l && !JSON.parse(localStorage.getItem('user'))) {
        localStorage.setItem('user', JSON.stringify(true))
    }
    const loggedIn =  JSON.parse(localStorage.getItem('user'));

    if (to.query.l) {
        const loginpath = localStorage.getItem('loginpath')
        if (loginpath) {
            localStorage.removeItem('loginpath')
            return next(loginpath)
        }
    } else if (!loggedIn && to.path !== '/login') {
        localStorage.setItem('loginpath', to.path)
    }

    if (authRequired && !loggedIn) {
        return next('/login');
    } else if (loggedIn && checkPath(to.path, onlyLoggedOut)) {
        return next('/hashtag-suggestions')
    }

    next();
})
